import { render, staticRenderFns } from "./airtelNumbers.vue?vue&type=template&id=5ef8c1d4"
import script from "./airtelNumbers.vue?vue&type=script&lang=js"
export * from "./airtelNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports